module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Bold-1f1ef0dfd2cd92b71a8d8e0a9d5a3b4e.ttf";